import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export interface ApiToken {
    id: string;
    name: string;
    /// Começo da chave, para distinguir uma da outra; a inteira só aparece na criação.
    prefix: string;
    createdAt: string;
    lastUsedAt?: string | null;
    revokedAt?: string | null;
    /// O que a chave pode fazer. Vazio quando é de acesso total.
    scopes: string[];
    /// Chave de antes das permissões por chave: faz tudo que a pessoa pode.
    fullAccess: boolean;
}

export interface ApiTokenCreated {
    info: ApiToken;
    token: string;
}

export class ApiTokenService extends BaseService {
    protected resourceName = 'crm/api-tokens';

    public async list(): Promise<AxiosResponse<{ data: ApiToken[] }>> {
        return await this.get('');
    }

    public async create(name: string, scopes: string[]): Promise<AxiosResponse<{ data: ApiTokenCreated }>> {
        return await this.post({ name, scopes }, '');
    }

    public async revoke(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
